import React from 'react';
import {useSelector} from "react-redux";
import Tooltip from "@material-ui/core/Tooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import RequestedAttacksDataTable
    from "../../../../../components/customBreachBits/requestedAttacks/RequestedAttacksDataTable";
import {HashLink as Link} from "react-router-hash-link";

const BreachBoardOverviewTab = ({children}, props) => {

    const {customerInView} = useSelector(({customer}) => customer);
    // const {boardActiveTab} = useSelector(({misc}) => misc);
    // const dispatch = useDispatch();
    // console.log("Customers in BreachBoardContent: ", customers);
    // const customer = getInViewCustomerObject(customerInView, customers);

    return (
        <div className={`bb-breachboard-overview`}>
            <div className={"row"}>
                <div className={"col-12"}>
                    <h3>Track your Insider Attacks <Tooltip title={"All Insider Attacks (both Internal Assessments and Attacks on Demand) will be displayed in the Insider Attacks Status Log.  Use this log to start the attack, access the attack timeline, and order more attacks."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                    <p>There are two types of Insider Attacks. <strong>Attack on Demand</strong> is a single attack against a single host of your choice. <strong>Internal Assessment</strong> is an objective-focused campaign of a limited duration with lateral movement. </p>
                    <p>Each type must be "ordered" using the interface below, at which point our
                        systems will provision the attack infrastructure. You can then launch the attack when you are ready. You can Quick-view the results here, or you can view even more details on each attack using the <Link to={"/board/CIRT/inspector"}>Attack Inspector</Link> (direct links are provided in the Quick-view interface).</p>

                </div>
                {/*<div className={"col-3 align-self-center text-center"}>*/}
                {/*    /!*<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("perimeter", "id")} isActive={bbDoesUserHaveAccessToModule(authUser, "perimeter")} iconSize={"80px"}/>*!/*/}
                {/*    <IconShowingIfCustomerHasAccessToModule module={"insider"}/>*/}
                {/*</div>*/}
                {/*<div className={"col-3 align-self-center text-center"}>*/}
                {/*    /!*<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("perimeter", "id")} isActive={bbDoesUserHaveAccessToModule(authUser, "perimeter")} iconSize={"80px"}/>*!/*/}
                {/*    <IconShowingIfCustomerHasAccessToModule module={"social"}/>*/}
                {/*</div>*/}
            </div>

            <div className="row tourStep-NewInsiderAttackButton">

                <div className="col-12">

                    <RequestedAttacksDataTable customerId={customerInView}/>

                </div>

            </div>
            {/*<div className="row">*/}
            {/*    <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12">*/}
            {/*        <TileCountLifetimeBreaches/>*/}
            {/*    </div>*/}
            {/*    <div className="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-12 tourStepVulnerableSystemTargetsTable">*/}
            {/*        <BreachesTable customerId={customerInView} past/>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<hr/>*/}
            {/*<div className={"tourStep2-2"}>*/}
            {/*    <h3>Metrics and CIRT Activity <Tooltip title={"These metrics describe facts discovered about your organization and about CIRT activities."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>*/}
            {/*    <p>These metrics help further describe your organization and CIRT activities, but they are not principle contributors to your risk score.</p>*/}
            {/*    <div className="row">*/}
            {/*        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">*/}
            {/*            <TileCountIdentitiesForCustomerInView/>*/}
            {/*        </div>*/}
            {/*        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">*/}
            {/*            <TileCountTargetsForCustomerInView/>*/}
            {/*        </div>*/}
            {/*        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">*/}
            {/*            <TileCountInScopeTargetsForCustomerInView/>*/}
            {/*        </div>*/}

            {/*        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">*/}
            {/*            <TileCountVectorsForCustomer/>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className="row">*/}
            {/*    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">*/}
            {/*        <TabbedClientInfoCard/>*/}
            {/*    </div>*/}

            {/*</div>*/}



        </div>
    )
};

BreachBoardOverviewTab.propTypes = {
};

export default BreachBoardOverviewTab;

